// extracted by mini-css-extract-plugin
module.exports = {"projectDashboardSkeleton":"ProjectDashboardSkeleton_projectDashboardSkeleton__VrHjI"};